/**
 * Created by Ning Jiang on 12/3/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData, ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {DWBackground} from "../../background/DWBackground";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {ScatterReelNearWinView} from "./ScatterReelNearWinView";

export class ScatterReelNearWinController extends ReelStopPresentationController {

    private _view:ScatterReelNearWinView;
    private _nearWinData:boolean[];
    private _bonusPositions:number[];
    private _freespinTriggered:boolean;
    private _isPlaying:boolean;
    private _isSoundPlaying:boolean;
    private _isBigWinSoundPlaying:boolean;

    constructor(index:number) {
        super(index, "scatterNearWin");

        this._view = new ScatterReelNearWinView();
        this._isPlaying = false;
        this._isSoundPlaying = false;
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._nearWinData = data.nearWinReels;
        this._freespinTriggered = data.freespinTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinReelEvent.REEL_ON_NEAR_WIN, (event:GameEvent) => this.onReelNearWin(event.params[0]));
    }

    private onReelNearWin(reelId:number):void {
        if(!this._nearWinData[reelId]) {
            if(!this._isBigWinSoundPlaying) {
                SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.ANTICIPATION_BIG_WIN);
                this._isBigWinSoundPlaying = true;
            }

            // exclude big win near win from scatter near win.
            return;
        }

        if(reelId !== 3) {
            return;
        }

        this._isPlaying = true;
        const reel:ReelController = Reels.getReel(reelId)!;
        reel.view.parent.addChild(reel.view);
        this._view.playFSNearWin(reelId);
        EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.ADD_SLOW_ATTENTION_SPIN_SYMBOL_TO_REEL, {
            reelId : 3,
            symName : ReelSymbolName.SCATTER,
            spinSpeed : 0.6,
            startPosition : -1,
            steps : 4,
            symbolState : DeadwoodGameConfig.instance.SYMBOL_STATES.spinAttention
        }));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_FRAME, true, 1.5));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0.6, 2));
        this.startAnticipationSound();
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId === 3 && this._isPlaying) {
            this._isPlaying = false;
            this._view.stopNearWin(data.reelId);

            if(!this._freespinTriggered) {
                EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_FRAME, false, 0.4));
                if(!this._nearWinData[4]) {
                    EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0, 0.35));
                }
                this.stopAnticipationSound();
                this.playAnticipationFailSound();
            } else {
                if(this._bonusPositions[0] > 0) {
                    // win fs and continue play B near win,
                    // continue play anticipation sound.
                } else {
                    this.stopAnticipationSound();
                    // win fs so don't play fail sound.
                }
            }
            return this.dispatchCompleteEvent(data.reelId);
        }

        if(data.reelId === 4) {
            SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.ANTICIPATION_BIG_WIN);
            this._isBigWinSoundPlaying = false;
        }

        if(data.reelId === 4 && this._freespinTriggered) {
            // for if quick stop so the near win is never triggered
            EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_FRAME, true, 1.5));
            EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0.6, 2));

            if(this._isSoundPlaying) {
                // to stop the sound if the anticipation sound last for change to win shootout fs.
                this.stopAnticipationSound();
                // No matter the shootout win or not, don't play fail because fs is won.
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.quickStop && data.reelId === 4) {
            // TODO:EventHandler.dispatchEvent(new GameEvent(SoundEvent.STOP_SOUND_EFFECT, TombstoneSoundConfig.instance.ANTICIPATION_REEL3, 0, 100));
            // TODO:EventHandler.dispatchEvent(new GameEvent(SoundEvent.STOP_SOUND_EFFECT, TombstoneSoundConfig.instance.ANTICIPATION_REEL4, 0, 100));
        }
        if(!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private startAnticipationSound():void {
        this._isSoundPlaying = true;
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.ANTICIPATION_SCATTER);
        SlotGame.sound.fadeAmbience(0.5, 2000);
    }

    private stopAnticipationSound():void {
        this._isSoundPlaying = false;
        SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.ANTICIPATION_SCATTER);
        SlotGame.sound.fadeAmbience(1, 2000);
    }

    private playAnticipationFailSound():void {
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.ANTICIPATION_SCATTER_FAIL);
    }

    protected resetFeature():void {
        this._view.reset();
        EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REMOVE_SLOW_ATTENTION_SPIN_SYMBOL_FROM_REEL, 3, ReelSymbolName.SCATTER));
    }
}